import React from "react";
import styled from "styled-components";

const Paragraph = styled.p`
    font-weight: thin;
    text-align: center;
    width: 100%;

    font-size: 1rem;
`;

const StatusMessage = ({message}) => (
    <Paragraph>{message}</Paragraph>
);

export default StatusMessage;